import { render, staticRenderFns } from "./ModalInfoMisFinanzas.vue?vue&type=template&id=31f90e7c&"
import script from "./ModalInfoMisFinanzas.vue?vue&type=script&lang=ts&"
export * from "./ModalInfoMisFinanzas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports